<template>
  <div
    id="app"
    :class="lang.params">
    <Header v-if="mediaType !== ''"/>
    <div class="main">
      <Home/>
      <Footer/>
    </div>
    <Modal v-if="sliderFlg" />
    <transition
      name="navFade"
      mode="out-in"
      @beforeLeave="navBeforeLeave"
      @leave="navLeave"
      @enter="navEnter">
      <Navigation
        v-if="navState"/>
    </transition>
    <BtnScrollTop
      v-if="mediaType === 'pc'"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'
import Reset from '@/assets/css/reset.css'
import Default from '@/assets/css/default.css'
import Header from '@/components/templates/Header'
import Modal from '@/components/templates/Modal'
import Navigation from '@/components/templates/Navigation'
import Footer from '@/components/templates/Footer'
import BtnScrollTop from '@/components/atoms/BtnScrollTop'
import Home from '@/pages/Home'

export default {
  name: 'App',
  metaInfo: {
    script: [
      { src: 'https://www.googletagmanager.com/gtag/js?id=' + process.env.TRACKING_ID, async: true },
      {
        innerHTML: "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '" + process.env.TRACKING_ID + "');",
        type: 'text/javascript'
      }
    ],
    link: [
      { rel: 'preload', href: require('@/assets/img/bk-top.png'), as: 'image' },
      { rel: 'apple-touch-icon', sizes: '180x180', href: require('@/assets/img/apple-touch-icon.png') },
      { rel: 'icon', href: require('@/assets/img/favicon.ico') }
    ],
    meta: [
      { name: 'description', content: 'ミュージアム展示ガイドアプリ「ポケット学芸員」―文字で、音声で、動画でこのアプリがあればあちこちのミュージアムであなた専属のガイドがつきます。' },
      { name: 'keywords', content: '音声ガイド,展示ガイドアプリ,ポケット学芸員,早稲田システム開発株式会社,収蔵品管理システム,美術館,博物館,資料館,埋蔵文化財,文学館,I.B.MUSEUM,アイビーミュージアム,収蔵品管理ソフト,Saas,ASP,クラウドコンピューティング,早稲田,作品管理システム,資料管理システム,文化財管理システム,所蔵品管理システム,収蔵資料管理システム,博物館データベース,美術館データベース' },
      { property: 'og:locale', content: 'ja_JP' },
      { property: 'fb:admins', content: '' },
      { property: 'fb:app_id', content: '120906861610342' },
      { property: 'og:site_name', content: 'ミュージアム展示ガイドアプリ「ポケット学芸員」' },
      { property: 'og:title', content: 'ミュージアム展示ガイドアプリ「ポケット学芸員」' },
      { property: 'og:url', content: process.env.URL },
      { property: 'og:image', content: process.env.URL + require('@/assets/img/img-ogp.png').replace('./', '') },
      { property: 'og:description', content: 'ミュージアム展示ガイドアプリ「ポケット学芸員」―文字で、画像で、音声で、動画で…あちこちのミュージアムで「あなた専属ガイド」になってくれる便利な無料アプリです。' },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'ミュージアム展示ガイドアプリ「ポケット学芸員」' },
      { name: 'twitter:description', content: 'ミュージアム展示ガイドアプリ「ポケット学芸員」―文字で、画像で、音声で、動画で…あちこちのミュージアムで「あなた専属ガイド」になってくれる便利な無料アプリです。' },
      { name: 'twitter:image:src', content: process.env.URL + require('@/assets/img/img-ogp.png').replace('./', '') }
    ]
  },
  components: {
    setting,
    mapGetters,
    Reset,
    Default,
    Header,
    Modal,
    Navigation,
    Footer,
    BtnScrollTop,
    Home
  },
  data () {
    return {
      setting
    }
  },
  computed: {
    ...mapGetters(['lang', 'sliderFlg', 'mediaType', 'navState'])
  },
  methods: {
    handleResize: function () {
      console.log('window.innerWidth:', window.innerWidth)
      // プリレンダリング時は処理しない
      if (!(window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerendering)) {
        if (window.innerWidth <= 959) {
          this.$store.dispatch('setMediaType', {
            type: 'sp'
          })
        } else {
          this.$store.dispatch('setMediaType', {
            type: 'pc'
          })
        }
      }
    },
    beforeLeave (element) {
    },
    navBeforeLeave () {
    },
    navLeave () {
    },
    navEnter () {
    },
    handleScroll: function (e) {
      console.log('handleScroll:', this.navState)
      if (this.navState || this.sliderFlg) {
        e.preventDefault()
      }
    },
    setBodyOverflow: function (state) {
      let element = document.querySelector('body')
      if (state) {
        element.style.overflow = 'hidden'
      } else {
        element.style.overflow = ''
      }
    }
  },
  created () {
    this.$store.dispatch('setMuseumList').then(res => {
      console.log(res)
    }, err => {
      console.log(err)
    })
  },
  mounted () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    document.addEventListener('touchmove', this.handleScroll, { passive: false })
    if (process.env.CLIENT_ENV !== 'production') {
      const head = document.getElementsByTagName('head')[0]
      const meta = document.createElement('meta')
      meta.setAttribute('name', 'robots')
      meta.setAttribute('content', 'noindex')
      head.appendChild(meta)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('touchmove', this.handleScroll, { passive: false })
  },
  watch: {
    'navState': function () {
      this.setBodyOverflow(this.navState)
    },
    'sliderFlg': function () {
      this.setBodyOverflow(this.sliderFlg)
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import './assets/css/mixins.css';
  @import './assets/css/variables.css';
</style>



// WEBPACK FOOTER //
// src/App.vue